import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { viewportConfig } from './animations';

export function HowItWorksSection() {
  const { t } = useTranslation();

  const steps = [
    { num: '01', titleKey: 'landing.howItWorks.step1.title', descKey: 'landing.howItWorks.step1.description', time: '0s' },
    { num: '02', titleKey: 'landing.howItWorks.step2.title', descKey: 'landing.howItWorks.step2.description', time: '30s' },
    { num: '03', titleKey: 'landing.howItWorks.step3.title', descKey: 'landing.howItWorks.step3.description', time: '60s' },
  ];

  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-muted/30">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportConfig}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('landing.howItWorks.title')}</h2>
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          {/* Horizontal Timeline SVG (hidden on mobile) */}
          <div className="hidden md:block absolute top-8 left-[16.67%] right-[16.67%] h-0.5">
            <svg className="w-full h-8 -mt-4" preserveAspectRatio="none">
              <motion.line
                x1="0"
                y1="16"
                x2="100%"
                y2="16"
                stroke="url(#timelineGrad)"
                strokeWidth="2"
                strokeLinecap="round"
                initial={{ pathLength: 0 }}
                whileInView={{ pathLength: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.5, ease: 'easeInOut' }}
              />
              <defs>
                <linearGradient id="timelineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#10b981" />
                  <stop offset="100%" stopColor="#0d9488" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                className="text-center relative"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={viewportConfig}
                transition={{ delay: i * 0.3, duration: 0.6 }}
              >
                <motion.div
                  className="inline-flex items-center justify-center h-16 w-16 rounded-full gradient-primary text-white text-2xl font-bold mb-4 relative z-10"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  {step.num}
                </motion.div>
                <h3 className="text-lg font-semibold mb-2">{t(step.titleKey)}</h3>
                <p className="text-sm text-muted-foreground">{t(step.descKey)}</p>
                <motion.div
                  className="mt-3 text-xs font-mono text-emerald-500 font-semibold"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.5 + i * 0.3 }}
                >
                  {step.time}
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
